import "./styles.css";

import avatarsSrc from "../../../assets/photos/avatars-row.png";

import shadow01 from "../../../assets/shadows/shadow-01.png";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Button from "../../../components/Button";

export default function Hero({ onCTA }) {
  return (
    <section className="hero">
      <div className="info-side">
        <span className="animated-badge">#ParaInfluencers</span>
        <h1>
          A primeira <h1 className="marked-text">rede social fitness </h1>
          brasileira chega ao mercado
        </h1>
        <h4>
          Esta é a oportunidade perfeita para influencers fitness serem
          pioneiros na{" "}
          <b>
            plataforma esculpida para transformar seguidores em clientes
            pagantes
          </b>
        </h4>

        <div className="hero-social-proof mt-2 mb-1">
          <img src={avatarsSrc} className="avatars-row" />
          <span>+ de 3.400 pessoas já utilizam o Ginastee</span>
        </div>
      </div>
    </section>
  );
}
